import React, { useEffect, useState } from 'react';
import '../../../index.scss';
import { userTypeList } from 'main_consts';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject } from 'main_type';
import { setLoadingRedux } from 'reducers/shareData/action';
// component
import DateSePickersTyping from 'components/DatePicker/DateSePickersTyping';
import WarehouseModal from 'components/Modal/WareHouseModal';
import Input from 'components/Material/Input';
import CheckBox from 'components/Material/Checkbox';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import Header from 'components/Header';
import Menu from '../../../components/Menu';
import {
  getDateDayPlus,
  getColWidthByField,
  getWarehouse,
  formatDate,
  inputChange,
  checkboxChange,
  initWhrehhouse,
} from '../../../main_func';
import { FormTitle, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';

import Table from '../../../components/Material/Table/index';
import { Imaster } from './type';

/** 進口艙單資料查詢 */
const ManifestQry = (): JSX.Element => {
  const dispatch = useDispatch();
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 業者名稱
    expressCnName: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    // 日期
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    vesselRegNo: '',
    dateCheck: false,
    endDateValid: true,
    startDateValid: true,
  };
  const apiName = 'manifestQry';
  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<Imaster[]>([]);
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());

  useEffect(() => {
    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      warehouse: master.warehouse,
      vesselRegNo: master.vesselRegNo,
      startDate: master.dateCheck
        ? formatDate(master.startDate, 'yyyyMMdd')
        : '',
      endDate: master.dateCheck ? formatDate(master.endDate, 'yyyyMMdd') : '',
    });

    const startDate = formatDate(master.startDate, 'MMdd');
    const EndDate = formatDate(master.endDate, 'MMdd');
    blobDownload(
      result,
      enqueueSnackbar,
      `${startDate}_${EndDate}_進口艙單資料查詢.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      warehouse: master.warehouse,
      vesselRegNo: master.vesselRegNo,
      startDate: master.dateCheck
        ? formatDate(master.startDate, 'yyyyMMdd')
        : '',
      endDate: master.dateCheck ? formatDate(master.endDate, 'yyyyMMdd') : '',
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const { data: dataTemp } = result.data;
    const data = dataTemp as Imaster[];
    if ((data || []).length > 0) {
      setColList(
        getColWidthByField([
          { headerName: '項次', field: 'itemNo' },
          { headerName: '進口日期', field: 'importDate' },
          { headerName: '船隻掛號', field: 'vesselRegNo' },
          { headerName: '主號', field: 'blNo' },
          { headerName: '艙號', field: 'manifNo' },
          { headerName: '總毛重', field: 'grossWeight' },
          { headerName: '件數', field: 'numberOfPackages' },
          { headerName: '件數單位', field: 'packageUnit' },
          { headerName: '貨櫃號碼', field: 'containerNo' },
          { headerName: '貨櫃尺寸', field: 'containerType' },
          { headerName: '封條號碼', field: 'sealNo' },
          { headerName: '船舶航次', field: 'voyageNo' },
          { headerName: '船名', field: 'shipName' },
          { headerName: '船舶呼號', field: 'vesselCallSign' },
          { headerName: '標記及號碼', field: 'marks' },
        ])
      );
      setRowData(data);
      setOpenSearchTable(true);
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    if (!master.dateCheck && master.vesselRegNo.length === 0) {
      enqueueSnackbar('【船隻掛號】、【進倉日期區間】擇一必填。', {
        variant: 'warning',
      });
      return;
    }

    if (
      (master.dateCheck && (!master.endDateValid || !master.startDateValid)) ||
      !(master.startDate && master.endDate)
    ) {
      return;
    }

    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }
      setFormError(warehouseResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);

    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">進口艙單資料查詢</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 進口艙單資料查詢
          </div>
        </div>
        <div className="input-area">
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*快遞倉站：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <WarehouseModal
                required
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              船隻掛號：
            </VcEGrid>

            <VcGrid item xs={12} sm={2}>
              <Input
                placeholder="船隻掛號/日期，擇一必填。"
                maxLength={6}
                value={master.vesselRegNo}
                name="vesselRegNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>進倉日期區間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 400 }}>
              <DateSePickersTyping
                key={random}
                required={master.dateCheck}
                disabled={!master.dateCheck}
                updateData={updateData}
                style={{ maxWidth: 400 }}
                names={['startDate', 'endDate']}
                data={master}
                seInterval={31}
              />
            </VcGrid>
            <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入日期查詢"
                checked={master.dateCheck}
                name="dateCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()([true, false])(e),
                  }));
                }}
              />
            </VcGrid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <Table
          key={randomValue}
          data={rowData as unknown as Iobject[]}
          columns={colList}
          rowsPerPageOptions={[100, 50, 10]}
          rootProps={{ style: { height: '400px' } }}
          pageSize={100}
        />
      )}
    </div>
  );
};

export default ManifestQry;
